import React from 'react';

// @ts-expect-error no types yet
import Button from '../Button/ButtonV2';

import './SideDrawerFooter.less';

interface SideDrawerFooterProps {
  cta: string;
  ctaOnClick?: React.MouseEventHandler<HTMLButtonElement>;
  style?: React.CSSProperties;
}

const SideDrawerFooter = ({ cta, ctaOnClick, style }: SideDrawerFooterProps): JSX.Element => (
  <div className="side-drawer__footer" style={style}>
    <Button className="side-drawer__footer__button" onClick={ctaOnClick}>
      {cta}
    </Button>
  </div>
);

export default SideDrawerFooter;
